export const ALLOWED_CHARACTERS = /[A-Za-z0-9-]/g;
export const DISALLOWED_CHARACTERS = /[^A-Z^a-z^0-9^-]/g;
const sanitizeCode = (code) => code.replace(DISALLOWED_CHARACTERS, '');
export default sanitizeCode;
